import axios, { AxiosResponse } from 'axios'
import { API_URL } from '../../../../../../constants'
import { ApiResponse } from '../../../../../common/api/response.types'
import { dedupe } from '../../Dashboard/core/api'
import { TIMELINE_API } from './consts'
import { TimelineQuery } from './query.types'
import { CandidatesResponse, TimelineResponse } from './response.types'

/** Одно окно таймлайна. Срез (валюта + границы) — ключ дедупликации. */
export const getTimeline = (q: TimelineQuery) =>
  dedupe<AxiosResponse<ApiResponse<TimelineResponse>>>(
    `timeline:${q.currency}:${q.from}:${q.to}`,
    () => axios.get<ApiResponse<TimelineResponse>>(`${API_URL}${TIMELINE_API}`, { params: q })
  )

/** Выплаты, с которыми депозит пытался смэтчиться, — по клику на точку. */
export const getDepositCandidates = (paymentTicketId: number) =>
  dedupe<AxiosResponse<ApiResponse<CandidatesResponse>>>(
    `timeline-candidates:${paymentTicketId}`,
    () =>
      axios.get<ApiResponse<CandidatesResponse>>(
        `${API_URL}${TIMELINE_API}/deposits/${paymentTicketId}/candidates`
      )
  )
